import { formatDateTimeFromISO } from "widgets/utils";

import type { User } from "@/graphql.ts";
import { getUserDisplayName } from "@/modules/users/utils/user.ts";
import type { TimeDetailsProps } from "@/ui-modules/core/DashboardTiles.tsx";

function getInfo(user: User, date: string): [string, string] {
  const userPart = user ? `by ${getUserDisplayName(user)}` : ""; // FIXME: Sould be JSX + strong here
  const datePart = date ? `on ${formatDateTimeFromISO(date)}` : "";

  return [userPart, datePart];
}

export function getTimeTooltipMessage(timeDetails: TimeDetailsProps): string {
  const [creationUserPart, creationDatePart] = getInfo(timeDetails.creator, timeDetails.creationDate);
  let [modificationUserPart, modificationDatePart] = getInfo(timeDetails.modder, timeDetails.modificationDate);
  const [_lastUsedUserPart, lastUsedDatePart] = getInfo(null, timeDetails.lastUseDate);

  // If the dates are the same, we just keep the creation date
  if (timeDetails.modificationDate == timeDetails.creationDate) {
    modificationDatePart = undefined;
    modificationUserPart = undefined;
  }

  const modificationPart =
    modificationUserPart || modificationDatePart
      ? `${creationUserPart || creationDatePart ? " m" : "M"}odified ${modificationUserPart}${
          modificationDatePart && " "
        }${modificationDatePart}.`
      : "";

  const lastUsePart = lastUsedDatePart
    ? `${creationUserPart || creationDatePart ? " l" : "L"}ast used ${lastUsedDatePart}`
    : "";

  const creationPart =
    creationUserPart || creationDatePart
      ? `Created ${creationUserPart}${creationDatePart && " "}${creationDatePart}${
          modificationPart || lastUsePart ? " and" : "."
        }`
      : "";

  return `${creationPart}${modificationPart}${lastUsePart}`;
}
